// extracted by mini-css-extract-plugin
export var container = "styles-module__container___ifriI";
export var formHeader = "styles-module__formHeader___Mg4Ko";
export var formColumn = "styles-module__formColumn___Vg_zH";
export var mobileGiftCardContainer = "styles-module__mobileGiftCardContainer___RN4LT";
export var cardColumn = "styles-module__cardColumn___dgmY5";
export var label = "styles-module__label___bAgrk";
export var sendDateHelperText = "styles-module__sendDateHelperText___kC1tJ";
export var formSection = "styles-module__formSection___EzYfF";
export var inputContainer = "styles-module__inputContainer___MSAzs";
export var fixedContainer = "styles-module__fixedContainer___w95Td";